import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Right-side drawer for forms. PrimeNG 15 uses p-sidebar; this is the only place to change for
 * the v20 p-drawer. Projected content is always instantiated, so hosts should put
 * `*ngIf="visible"` on the inner form to get a fresh form on every open.
 */
@Component({
  selector: 'app-form-drawer',
  template: `
    <p-sidebar
      [visible]="visible"
      (visibleChange)="onVisibleChange($event)"
      position="right"
      appendTo="body"
      [modal]="true"
      [dismissible]="dismissible"
      [blockScroll]="true"
      [showCloseIcon]="false"
      [styleClass]="'jf-drawer ' + styleClass"
      [style]="{ width: width }">
      <ng-content></ng-content>
    </p-sidebar>
  `,
})
export class FormDrawerComponent {
  @Input() visible = false;
  @Input() width = 'min(1040px, 100vw)';
  @Input() styleClass = '';
  @Input() dismissible = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();

  onVisibleChange(v: boolean): void {
    if (!v) this.close();
  }

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.closed.emit();
  }
}
